export function isWebCodecsPreviewEnabled(): boolean {
  if (typeof window === "undefined") return false;

  try {
    const sp = new URLSearchParams(window.location.search);
    const qp = sp.get("vb_webcodecs");
    if (qp === "1" || qp === "true") return true;
  } catch {
    // ignore
  }

  try {
    return window.localStorage.getItem("vb:editor2:webcodecs") === "1";
  } catch {
    return false;
  }
}

